import DesignTokens from '@tableau/design-tokens';
import { style } from 'typestyle';

export const UploadBundleDialogStyles = {
  /** Centered column for the uploading / tracking (spinner + message) phases. */
  statusState: style({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '24px 0',
  }),

  statusMessage: style({
    marginTop: 12,
    color: DesignTokens.color.font.default.default,
  }),

  statusSubMessage: style({
    marginTop: 4,
    color: DesignTokens.color.font.default.secondary,
  }),


  progressBar: style({
    width: '100%',
  }),

  /** The success / error body copy block. */
  resultBlock: style({
    marginTop: 8,
  }),

  /** Spacing above an inline alert (e.g. an invalid file). */
  alert: style({
    marginTop: 12,
  }),
};
